import React from 'react';
import {Controller} from "react-hook-form";
import Switch from "@mui/material/Switch";
import {FormControlLabel} from "@mui/material";
import {Loader} from "../loaders";


export const SwitchMain = (
    {
        name,
        label,
        labelPlacement = 'start',
        rules,
        disabled,
        control,
        styleWrapper = {},
        onChange,
        loading
    }
) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({field}) => {
                return (
                    <div className="switch-main-wrapper" style={styleWrapper}>
                        <FormControlLabel
                            {...field}
                            value={field?.value}
                            disabled={disabled}
                            control={
                                loading ?
                                    <Loader styles={{width: 20, height: 20, color: "#FFC107"}} />
                                    :
                                    <Switch
                                        onChange={(event, checked) => {
                                            field?.onChange(event, checked);
                                            if (onChange) onChange(event, checked)
                                        }
                                        }
                                        checked={field?.value}
                                    />
                            }
                            label={label || ''}
                            labelPlacement={labelPlacement}
                        />
                    </div>
                )
            }}
        />

    );
};

